
export const  Features = {
    reports: 'Report',
    userManagement: 'User Management',
    pushNotification: 'Push Notification',
    ifaList: 'IFA List',
    updateContent: 'Update Content',
    deviceManagement: 'Device Management',
    partners: 'Partners',
    investors: 'Investors',
    products:'Products',
    downloads:'Downloads',
    nfo :'NFO',
    ceoDesk:'CEO Desk',
    latestNews :'Latest News',
    media:'Media',
    careers: 'Careers',
    contactUs:'Contact Us',
    userData:'User Data',
    relationshipManager:'Relationship Manager',
    navDividends:'Nav & Dividends',
    advertisement:'Advertisement',
    expenseRatio:'Expense Ratio',
    digitalFactsheet:'Digital Factsheet',
     aboutUs: 'About us',
     IAPpage: 'IAP Page'
}

export const DependentFeatures = {
        'Products':'Products',
        'Investors':'Investors',
        'Partners':'Partners',
        'Downloads':'Downloads',
        'NFO':'NFO',
        'CEO Desk':'CEO Desk',
        'Latest News':'Latest News',
        'Media': 'Media',
        'Careers':'Careers',
        'Contact Us':'Contact Us',
        'User Data':'User Data',
        'Relationship Manager':'Relationship Manager',
        'Nav & Dividends':'Nav & Dividends',
        'Advertisement':'Advertisement',
        'Expense Ratio':'Expense Ratio',
        'Digital Factsheet': 'Digital Factsheet'
}

export const DependentFeaturesByKey = {
    'Update Content' : {
        'Products':'Products',
        'Investors':'Investors',
        'Partners':'Partners',
        'Downloads':'Downloads',
        'NFO':'NFO',
        'CEO Desk':'CEO Desk',
        'Latest News':'Latest News',
        'Media': 'Media',
        'Careers':'Careers',
        'Contact Us':'Contact Us',
        'User Data':'User Data',
        'Relationship Manager':'Relationship Manager',
        'Nav & Dividends':'Nav & Dividends',
        'Advertisement':'Advertisement',
        'Expense Ratio':'Expense Ratio',
        'Digital Factsheet': 'Digital Factsheet'
    }
}